import Plus from '@service-victoria/component-library/components/Icons/Plus';
import device from '@service-victoria/component-library/utils/device';
import styled, { css } from 'styled-components';

export const NotificationWrapper = styled.div`
  margin-bottom: -46px;
`;

export const GuestsButtonWrapper = styled.div`
  margin-top: 36px;
  margin-bottom: 84px;
`;

export const Form = styled.form<{ showAccordionView?: boolean }>`
  ${({ showAccordionView }) => {
    if (!showAccordionView) {
      return css`
        padding: 20px 20px 0;

        @media ${device.isDesktop} {
          padding: 42px 50px 0;
        }
      `;
    }
  }}
`;

export const BottomContainer = styled.div<{ showAccordionView?: boolean }>`
  ${({ showAccordionView }) => {
    if (showAccordionView) {
      return css`
        padding: 0 20px;

        @media ${device.isDesktop} {
          padding: 0 50px;
        }
      `;
    }
  }}
`;

export const SingleViewWrapper = styled.div`
  margin-bottom: 12px;
`;

export const PlusIcon = styled(Plus)`
  height: 12px;
  width: 12px;
  margin-right: 10px;

  path {
    fill: currentColor;
  }
`;
